export default class LogBox {
    static ignoreLogs(pattern?: string[]){}
}